module.exports = __webpack_public_path__ + "img/bmw-1536x714.43c46be8.png";